import axios from "axios";
import { ProvinceModel } from "../entities/ProvinceModel";
import { CityDistrictModel } from "../entities/CityDistrictModel";
import { SubDistrictModel } from "../entities/SubDistrictModel";
import { VillagesModel } from "../entities/VillagesModel";

const API_URL = `${process.env.REACT_APP_API_URL}provinces`;
const API_URL_DISTRICT = `${process.env.REACT_APP_API_URL}city-districts`;
const API_URL_SUB_DISTRICT = `${process.env.REACT_APP_API_URL}subdistricts`;

export const fetchProvince = async (): Promise<ProvinceModel[]> => {
    const response = await axios.get(API_URL); // Use axios to make the GET request.
    const data = response.data.data; // Access the nested 'data' array.
    
    // Map the response to Province instances.
    return data.map((item: any) => new ProvinceModel(item.id, item.name));
};

export const fetchDistricts = async (provinceId: number): Promise<CityDistrictModel[]> => {
    try {
        const response = await axios.get(`${API_URL}/${provinceId}/city-districts`);
        const data = response.data.data; // Access the nested 'data' array.

        // Map the response to DistrictModel instances.
        return data.map((item: any) => new CityDistrictModel(item.id, item.name, item.province_id));
    } catch (error) {
        console.error("Error fetching districts:", error);
        throw error;
    }
};

export const fetchSubDistricts = async (districtId: string): Promise<SubDistrictModel[]> => {
    try {
        const response = await axios.get(`${API_URL_DISTRICT}/${districtId}/subdistricts`);
        const data = response.data.data; // Access the nested 'data' array.

        // Map the response to DistrictModel instances.
        return data.map((item: any) => new SubDistrictModel(item.id, item.name, item.city_district_id));
    } catch (error) {
        console.error("Error fetching sub districts:", error);
        throw error;
    }
};

export const fetchVillages = async (subdistrict_id: string): Promise<VillagesModel[]> => {
    try {
        const response = await axios.get(`${API_URL_SUB_DISTRICT}/${subdistrict_id}/villages`);
        const data = response.data.data; // Access the nested 'data' array.

        // Map the response to DistrictModel instances.
        return data.map((item: any) => new VillagesModel(item.id, item.name, item.subdistrict_id));
    } catch (error) {
        console.error("Error fetching villages:", error);
        throw error;
    }
};